import React from 'react';

const ActionCableContext = React.createContext(null);

export default ActionCableContext;